import dividersTemplates from './dividersTemplates';

import { DIVIDERS } from 'common/constants';

const dividersSet = [
  {
    codeTemplate: dividersTemplates.darkBackgrounds,
    label: 'Dark Backgrounds',
    options: {layout: DIVIDERS.dark},
    bgColor: 'heavy-blue'
  },
  {
    codeTemplate: dividersTemplates.darkSideBar,
    label: 'Dark Sidebar',
    options: {layout: DIVIDERS.sidebar},
    bgColor: 'heavy-blue'
  },
  {
    codeTemplate: dividersTemplates.defaultDivider,
    label: 'Header and Footer',
    options: {},
  },
  {
    codeTemplate: dividersTemplates.lightBackgrounds,
    label: 'Light Backgrounds',
    options: {layout: DIVIDERS.light},
  },
  {
    codeTemplate: dividersTemplates.defaultDivider,
    label: 'Tables and Lists',
    options: {}
  },
  {
    codeTemplate: dividersTemplates.tooltipsAndPopovers,
    label: 'Tooltips and Popovers',
    options: {layout: DIVIDERS.tooltips},
    bgColor: 'heavy-blue'
  }
];

export default dividersSet;



// WEBPACK FOOTER //
// ./src/containers/elements/Dividers/constants/dividersSet.js